import styled from '@emotion/styled'

interface Props {
  wizard?: boolean
  resize?: boolean
}

const H2 = styled.h2<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    fontFamily: theme.fonts.families.headline,
    fontSize: '22px',
    fontWeight: 'bold',
    color: theme.colors.primary,
    letterSpacing: '1.1px',
    lineHeight: '26px',
    [theme.mediaQueries.maxDesktop]: {
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0.8px',
    },
  }),
  (props) =>
    props.wizard && {
      fontSize: props.theme.fonts.sizes.H2.wizard,
      fontWeight: 400,
      letterSpacing: '0.04em',
      padding: 0,
      lineHeight: '1.3em',
      margin: '0px',
    },
  ({ resize }) => !!resize && { fontSize: '1.2vw', lineHeight: '1.22vw' }
)

export default H2
